import { styled, ListItemButton, Icon } from '@mui/material';

export const StyledListItemButton = styled(ListItemButton)(({ theme }) => ({
    '&:hover': {
        backgroundColor: theme.palette._components.navigation.hover,
        cursor: 'pointer',
    },
    '&.active': {
        backgroundColor: theme.palette._components.navigation.active,
    },
}));

export const ItemContainer = styled('div')(({ theme }) => ({
    gap: theme.spacing(2),
    display: 'flex',
    alignItems: 'center',
    padding: theme.spacing(0.5),
    width: '100%',
    color: theme.palette.primary.contrastText,
    fontWeight: theme.typography.fontWeightBold,
    fontSize: theme.typography.body1.fontSize,
    fontFamily: theme.typography.fontFamily,

    '&.disabled': {
        cursor: 'not-allowed',
        color: theme.palette.text.disabled,
    },
}));

export const StyledIcon = styled(Icon, {
    shouldForwardProp: (prop) => prop !== '$isHeader',
})(({ $isHeader }) => ({
    fontSize: $isHeader ? '32px' : '24px',
}));

export const GroupHeader = styled('div')(({ theme }) => ({
    padding: `${theme.spacing(1)} ${theme.spacing(2)}`,
    fontSize: theme.typography.caption.fontSize,
    lineHeight: theme.typography.caption.lineHeight || '16px',
    fontWeight: theme.typography.fontWeightBold,
    color: theme.palette._components.navigation.header,
}));

export const CustomDivider = styled('div')(({ theme }) => ({
    borderTop: `1px solid rgba(255, 255, 255, 0.06)`,
    margin: `${theme.spacing(1)} 0`,
}));
